import React from "react";
import "./NotFound.css";
const NotFound = () => {
  return (
    <div>
      <img
        className="img-NotFound"
        src="https://cdn1.vectorstock.com/i/1000x1000/77/15/404-error-page-not-found-plug-graphic-background-vector-21467715.jpg"
        alt=""
      />
    </div>
  );
};

export default NotFound;
